import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const TOKEN_KEY = "aditi_token";
const USER_KEY = "aditi_user";

export const auth = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  getUser: () => {
    const u = localStorage.getItem(USER_KEY);
    return u ? JSON.parse(u) : null;
  },
  setUser: (u) => localStorage.setItem(USER_KEY, JSON.stringify(u)),
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
};

export const api = axios.create({
  baseURL: API,
  // 15s timeout — prevents UI from hanging forever on a stalled backend / network.
  // Long-running ops (settlement, OAuth exchange) explicitly override via { timeout: 60000 }.
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const t = auth.getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401) {
      const detail = e.response?.data?.detail || "";
      // Persist a one-shot reason that login page can read after redirect
      try {
        if (typeof detail === "string" && detail.toLowerCase().includes("another device")) {
          sessionStorage.setItem("aditi_logout_reason", detail);
        } else if (typeof detail === "string" && detail) {
          sessionStorage.setItem("aditi_logout_reason", detail);
        }
      } catch (_) { /* sessionStorage may be blocked */ }
      auth.clear();
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(e);
  }
);

export function errMsg(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return e?.message || fallback;
}

export function fmtINR(n, opts = {}) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  // Indian number format without currency symbol (per spec: no ₹ anywhere)
  const sign = n < 0 ? "-" : "";
  return sign + new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2, maximumFractionDigits: 2, ...opts,
  }).format(Math.abs(n));
}

export function fmtNum(n, dp = 2) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Number(n).toLocaleString("en-IN", { minimumFractionDigits: dp, maximumFractionDigits: dp });
}
